// {
//   LOCAL_KEY_SYS_ON_OFF,
//     COS_CODE_MUTE,
//     COS_CODE_VDRTC,
//     COS_CODE_VIRTC,
//     COS_CODE_SPT,
//     COS_CODE_SNT,
//     COS_CODE_PP,
//     KBD_CODE_F7,
//     KBD_CODE_F8,
//     LOCAL_KEY_MODE_CMD_ON_OFF,
//     LOCAL_KEY_MODE_CMD_NAMEPLATE_ON_OFF,
//     LOCAL_KEY_NEXT_MODE,
//     LOCAL_KEY_MODE_CMD_NAMEPLATE_NEXT_MODE,
//     LOCAL_KEY_MODE_CMD_NAMEPLATE_NEX_COLOR,
//     KBD_CODE_PSCREEN;
// }
// {
//   KBD_CODE_GRAVE,
//     LOCAL_KEY_BLE_SHFIT1,
//     LOCAL_KEY_BLE_SHFIT2,
//     LOCAL_KEY_BLE_SHFIT3,
//     LOCAL_KEY_ESB_24g,
//     KBD_CODE_5,
//     KBD_CODE_6,
//     KBD_CODE_7,
//     KBD_CODE_8,
//     KBD_CODE_9,
//     KBD_CODE_0,
//     LOCAL_KEY_MODE_LIGHTNESS_REDUCE,
//     LOCAL_KEY_MODE_LIGHTNESS_ADD,
//     KBD_CODE_BACKSPACE,
//     KBD_CODE_INSERT;
// }
// {
//   KBD_CODE_TAB,
//     KBD_CODE_Q,
//     KBD_CODE_W,
//     KBD_CODE_E,
//     LOCAL_KEY_SYS_RECOVER,
//     KBD_CODE_T,
//     KBD_CODE_Y,
//     KBD_CODE_U,
//     KBD_CODE_I,
//     KBD_CODE_O,
//     LOCAL_KEY_PAUSE_BATT_SHOW,
//     KBD_CODE_LBRACKET,
//     KBD_CODE_RBRACKET,
//     KBD_CODE_BSLASH,
//     KBD_CODE_DELETE;
// }
// {
//   KBD_CODE_CAPSLOCK,
//     KBD_CODE_A,
//     KBD_CODE_S,
//     KBD_CODE_D,
//     KBD_CODE_F,
//     KBD_CODE_G,
//     KBD_CODE_H,
//     KBD_CODE_J,
//     KBD_CODE_K,
//     KBD_CODE_L,
//     KBD_CODEC_SCOLON,
//     KBD_CODE_QUOTE,
//     KBD_CODE_ENTER,
//     KBD_CODE_PAUSE,
//     KBD_CODE_SCROLLLOCK;
// }
// {
//   KBD_CODE_LEFSHIFT,
//     KBD_CODE_Z,
//     KBD_CODE_X,
//     KBD_CODE_C,
//     KBD_CODE_V,
//     KBD_CODE_B,
//     KBD_CODE_N,
//     KBD_CODE_M,
//     LOCAL_KEY_RIGHT_NAMEPLATE_LIGHTNESS_REDUCE,
//     LOCAL_KEY_RIGHT_NAMEPLATE_LIGHTNESS_ADD,
//     KBD_CODE_SLASH,
//     KBD_CODE_RIGHTSHIFT,
//     KBD_CODE_PGDOWN,
//     KBD_CODE_PGUP,
//     KBD_CODE_HOME;
// }
// {
//   KBD_CODE_LEFTCTL,
//     KBD_CODE_LEFTGUI,
//     KBD_CODE_LEFTALT,
//     KBD_CODE_SPACE,
//     __________,
//     __________,
//     LOCAL_KEY_MODE_SPEED_ADD,
//     LOCAL_KEY_LEFT_NAMEPLATE_LIGHTNESS_REDUCE,
//     LOCAL_KEY_MODE_SPEED_REDUCE,
//     __________,
//     LOCAL_KEY_FUN_LEFT,
//     KBD_CODE_RIGHTGUI,
//     LOCAL_KEY_LEFT_NAMEPLATE_LIGHTNESS_ADD,
//     KBD_CODE_RIGHTCTL,
//     KBD_CODE_END;
// }

export const srcKeys = [
  { index: 0, style: { top: "0%", left: "0%" } },
  { index: 1, style: { top: "0%", left: "7.0%" } },
  { index: 2, style: { top: "0%", left: "12.5%" } },
  { index: 3, style: { top: "0%", left: "18.0%" } },
  { index: 4, style: { top: "0%", left: "23.6%" } },
  { index: 5, style: { top: "0%", left: "30.5%" } },
  { index: 6, style: { top: "0%", left: "36.1%" } },
  { index: 7, style: { top: "0%", left: "41.6%" } },
  { index: 8, style: { top: "0%", left: "47.2%" } },
  { index: 9, style: { top: "0%", left: "54.2%" } },
  { index: 10, style: { top: "0%", left: "59.7%" } },
  { index: 11, style: { top: "0%", left: "65.3%" } },
  { index: 12, style: { top: "0%", left: "70.8%" } },
  { index: 13, style: { top: "0%", left: "77.7%" } },
  { index: 14, style: { top: "0%", left: "84.7%" } },
  { index: 89, style: { top: "0%", left: "90.2%" } },
  { index: 88, style: { top: "0%", left: "95.8%" } },

  { index: 25, style: { top: "20.5%", left: "0%" } },
  { index: 26, style: { top: "20.5%", left: "5.6%" } },
  { index: 27, style: { top: "20.5%", left: "11.1%" } },
  { index: 28, style: { top: "20.5%", left: "16.7%" } },
  { index: 29, style: { top: "20.5%", left: "22.2%" } },
  { index: 30, style: { top: "20.5%", left: "27.7%" } },
  { index: 31, style: { top: "20.5%", left: "33.3%" } },
  { index: 32, style: { top: "20.5%", left: "38.8%" } },
  { index: 33, style: { top: "20.5%", left: "44.4%" } },
  { index: 34, style: { top: "20.5%", left: "50.0%" } },
  { index: 35, style: { top: "20.5%", left: "55.5%" } },
  { index: 36, style: { top: "20.5%", left: "61.0%" } },
  { index: 37, style: { top: "20.5%", left: "66.6%" } },
  { index: 38, style: { top: "20.5%", left: "72.5%", width: "9%" } },
  { index: 39, style: { top: "20.5%", left: "84.7%" } },
  { index: 114, style: { top: "20.5%", left: "90.2%" } },
  { index: 113, style: { top: "20.5%", left: "95.8%" } },

  { index: 50, style: { top: "36.3%", left: "0%", width: "6.2%" } },
  { index: 51, style: { top: "36.3%", left: "8.3%" } },
  { index: 52, style: { top: "36.3%", left: "14%" } },
  { index: 53, style: { top: "36.3%", left: "19.4%" } },
  { index: 54, style: { top: "36.3%", left: "24.9%" } },
  { index: 55, style: { top: "36.3%", left: "30.5%" } },
  { index: 56, style: { top: "36.3%", left: "36.0%" } },
  { index: 57, style: { top: "36.3%", left: "41.6%" } },
  { index: 58, style: { top: "36.3%", left: "47.2%" } },
  { index: 59, style: { top: "36.3%", left: "52.7%" } },
  { index: 60, style: { top: "36.3%", left: "58.2%" } },
  { index: 61, style: { top: "36.3%", left: "63.8%" } },
  { index: 62, style: { top: "36.3%", left: "69.4%" } },
  { index: 63, style: { top: "36.3%", left: "75.0%", width: "6.2%" } },
  { index: 64, style: { top: "36.3%", left: "84.7%" } },
  { index: 139, style: { top: "36.3%", left: "90.2%" } },
  { index: 112, style: { top: "36.3%", left: "95.8%" } },

  { index: 75, style: { top: "52.7%", left: "0%", width: "8%" } },
  { index: 76, style: { top: "52.7%", left: "9.8%" } },
  { index: 77, style: { top: "52.7%", left: "15.3%" } },
  { index: 78, style: { top: "52.7%", left: "20.9%" } },
  { index: 79, style: { top: "52.7%", left: "26.4%" } },
  { index: 80, style: { top: "52.7%", left: "31.9%" } },
  { index: 81, style: { top: "52.7%", left: "37.5%" } },
  { index: 82, style: { top: "52.7%", left: "43.0%" } },
  { index: 83, style: { top: "52.7%", left: "48.6%" } },
  { index: 84, style: { top: "52.7%", left: "54.1%" } },
  { index: 85, style: { top: "52.7%", left: "59.7%" } },
  { index: 86, style: { top: "52.7%", left: "65.3%" } },
  { index: 87, style: { top: "52.7%", left: "70.8%", width: "10.2%" } },

  { index: 100, style: { top: "69%", left: "0%", width: "10.5%" } },
  { index: 101, style: { top: "69%", left: "12.5%" } },
  { index: 102, style: { top: "69%", left: "18.1%" } },
  { index: 103, style: { top: "69%", left: "23.6%" } },
  { index: 104, style: { top: "69%", left: "29.2%" } },
  { index: 105, style: { top: "69%", left: "34.7%" } },
  { index: 106, style: { top: "69%", left: "40.2%" } },
  { index: 107, style: { top: "69%", left: "45.7%" } },
  { index: 108, style: { top: "69%", left: "51.3%" } },
  { index: 109, style: { top: "69%", left: "56.9%" } },
  { index: 110, style: { top: "69%", left: "62.5%" } },
  { index: 111, style: { top: "69%", left: "68.1%", width: "13.2%" } },
  { index: 137, style: { top: "69%", left: "90.2%" } },

  { index: 125, style: { top: "85%", left: "0%", width: "6.2%" } },
  { index: 126, style: { top: "85%", left: "8.3%" } },
  { index: 127, style: { top: "85%", left: "13.8%", width: "6.2%" } },
  { index: 128, style: { top: "85%", left: "22.2%", width: "37.0%" } },
  { index: 135, style: { top: "85%", left: "61.1%", width: "6.2%" } },
  { index: 136, style: { top: "85%", left: "69.4%" } },
  { index: 138, style: { top: "85%", left: "75.0%", width: "6.2%" } },
  { index: 133, style: { top: "85%", left: "84.7%" } },
  { index: 132, style: { top: "85%", left: "90.2%" } },
  { index: 131, style: { top: "85%", left: "95.8%" } },
];

export const dstKeys = {
  "#00070004": {
    text: [{ text: "A", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070005": {
    text: [{ text: "B", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070006": {
    text: [{ text: "C", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070007": {
    text: [{ text: "D", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070008": {
    text: [{ text: "E", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070009": {
    text: [{ text: "F", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000A": {
    text: [{ text: "G", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000B": {
    text: [{ text: "H", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000C": {
    text: [{ text: "I", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000D": {
    text: [{ text: "J", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000E": {
    text: [{ text: "K", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000F": {
    text: [{ text: "L", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070010": {
    text: [{ text: "M", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070011": {
    text: [{ text: "N", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070012": {
    text: [{ text: "O", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070013": {
    text: [{ text: "P", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070014": {
    text: [{ text: "Q", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070015": {
    text: [{ text: "R", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070016": {
    text: [{ text: "S", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070017": {
    text: [{ text: "T", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070018": {
    text: [{ text: "U", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070019": {
    text: [{ text: "V", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001A": {
    text: [{ text: "W", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001B": {
    text: [{ text: "X", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001C": {
    text: [{ text: "Y", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001D": {
    text: [{ text: "Z", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001E": {
    text: [
      { text: "!", style: { top: "30%", fontSize: "1.2em" } },
      { text: "1", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#0007001F": {
    text: [
      { text: "@", style: { top: "25%", fontSize: "1.2em" } },
      { text: "2", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070020": {
    text: [
      { text: "#", style: { top: "30%", fontSize: "1.2em" } },
      { text: "3", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070021": {
    text: [
      { text: "$", style: { top: "30%", fontSize: "1.2em" } },
      { text: "4", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070022": {
    text: [
      { text: "%", style: { top: "30%", fontSize: "1.2em" } },
      { text: "5", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070023": {
    text: [
      { text: "^", style: { top: "30%", fontSize: "1.2em" } },
      { text: "6", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070024": {
    text: [
      { text: "&", style: { top: "30%", fontSize: "1.2em" } },
      { text: "7", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070025": {
    text: [
      { text: "*", style: { top: "30%", fontSize: "1.2em" } },
      { text: "8", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070026": {
    text: [
      { text: "(", style: { top: "30%", fontSize: "1.2em" } },
      { text: "9", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070027": {
    text: [
      { text: ")", style: { top: "30%", fontSize: "1.2em" } },
      { text: "0", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070028": { text: [{ text: "Enter", style: { top: "50%" } }] },
  "#00070029": { text: [{ text: "Esc", style: { top: "50%" } }] },
  "#0007002A": {
    text: [{ text: "Backspace", style: { top: "50%" } }],
  },
  "#0007002B": {
    text: [{ text: "Tab", style: { top: "50%" } }],
  },
  "#0007002C": {
    text: [{ text: "Space", style: { top: "50%" } }],
  },
  "#0007002D": {
    text: [
      { text: "_", style: { top: "15%", fontSize: "1.4em" } },
      { text: "-", style: { top: "60%", fontSize: "1.4em" } },
    ],
  },
  "#0007002E": {
    text: [
      { text: "+", style: { top: "30%", fontSize: "1.4em" } },
      { text: "=", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#0007002F": {
    text: [
      { text: "{", style: { top: "25%", fontSize: "1.3em" } },
      { text: "[", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070030": {
    text: [
      { text: "}", style: { top: "25%", fontSize: "1.3em" } },
      { text: "]", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070031": {
    text: [
      { text: "|", style: { top: "25%", fontSize: "1.3em" } },
      { text: "\\", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070033": {
    text: [
      { text: ":", style: { top: "25%", fontSize: "1.4em" } },
      { text: ";", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#00070034": {
    text: [
      { text: '"', style: { top: "30%", fontSize: "1.4em" } },
      { text: "'", style: { top: "75%", fontSize: "1.4em" } },
    ],
  },
  "#00070035": {
    text: [
      { text: "~", style: { top: "30%", fontSize: "1.7em" } },
      { text: "`", style: { top: "90%", fontSize: "1.7em" } },
    ],
  },
  "#00070036": {
    text: [
      { text: "<", style: { top: "25%", fontSize: "1.8em" } },
      { text: ",", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070037": {
    text: [
      { text: ">", style: { top: "25%", fontSize: "1.8em" } },
      { text: ".", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070038": {
    text: [
      { text: "?", style: { top: "25%", fontSize: "1.5em" } },
      { text: "/", style: { top: "70%", fontSize: "1.4em" } },
    ],
  },
  "#00070039": {
    text: [
      { text: "Caps", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#0007003A": { text: [{ text: "F1", style: { top: "50%" } }] },
  "#0007003B": { text: [{ text: "F2", style: { top: "50%" } }] },
  "#0007003C": { text: [{ text: "F3", style: { top: "50%" } }] },
  "#0007003D": { text: [{ text: "F4", style: { top: "50%" } }] },
  "#0007003E": { text: [{ text: "F5", style: { top: "50%" } }] },
  "#0007003F": { text: [{ text: "F6", style: { top: "50%" } }] },
  "#00070040": { text: [{ text: "F7", style: { top: "50%" } }] },
  "#00070041": { text: [{ text: "F8", style: { top: "50%" } }] },
  "#00070042": { text: [{ text: "F9", style: { top: "50%" } }] },
  "#00070043": { text: [{ text: "F10", style: { top: "50%" } }] },
  "#00070044": { text: [{ text: "F11", style: { top: "50%" } }] },
  "#00070045": { text: [{ text: "F12", style: { top: "50%" } }] },
  "#00070068": { text: [{ text: "F13", style: { top: "50%" } }] },
  "#000700FF": {
    text: [
      { text: "~", style: { top: "30%", fontSize: "1.2em" } },
      { text: "#", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070046": {
    text: [
      { text: "Print", style: { top: "35%" } },
      { text: "Screen", style: { top: "65%" } },
    ],
  },
  "#00070047": {
    text: [
      { text: "Scroll", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070048": {
    text: [{ text: "Pause", style: { top: "50%" } }],
  },
  "#00070049": {
    text: [{ text: "Insert", style: { top: "50%" } }],
  },
  "#0007004A": {
    text: [{ text: "Home", style: { top: "50%" } }],
  },
  "#0007004B": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Up", style: { top: "65%" } },
    ],
  },
  "#0007004C": {
    text: [{ text: "Delete", style: { top: "50%" } }],
  },
  "#0007004D": {
    text: [{ text: "End", style: { top: "50%" } }],
  },
  "#0007004E": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Down", style: { top: "65%" } },
    ],
  },
  "#0007004F": {
    text: [{ text: "→", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070050": {
    text: [{ text: "←", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070051": {
    text: [{ text: "↓", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070052": {
    text: [{ text: "↑", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070053": {
    text: [
      { text: "Num", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070054": {
    text: [{ text: "/", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070055": {
    text: [{ text: "*", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070056": {
    text: [{ text: "-", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070057": {
    text: [{ text: "+", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070058": {
    text: [{ text: "Enter", style: { top: "50%" } }],
  },
  "#00070059": {
    text: [{ text: "1", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005A": {
    text: [{ text: "2", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005B": {
    text: [{ text: "3", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005C": {
    text: [{ text: "4", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005D": {
    text: [{ text: "5", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005E": {
    text: [{ text: "6", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005F": {
    text: [{ text: "7", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070060": {
    text: [{ text: "8", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070061": {
    text: [{ text: "9", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070062": {
    text: [{ text: "0", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070063": {
    text: [{ text: ".", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070065": {
    text: [{ text: "Menu", style: { top: "50%" } }],
  },
  "#000700E0": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E1": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E2": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E3": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },
  "#000700E4": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E5": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E6": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E7": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },

  "#000C00E2": {
    text: [{ text: "Mute", style: { top: "50%" } }],
  },
  "#000C00E9": {
    text: [{ text: "VolUp", style: { top: "50%" } }],
  },
  "#000C00EA": {
    text: [{ text: "VolDn", style: { top: "50%" } }],
  },
  "#000C00B6": {
    text: [{ text: "|◀", style: { top: "50%" } }],
  },
  "#000C00B5": {
    text: [{ text: "▶|", style: { top: "50%" } }],
  },
  "#000C00CD": {
    text: [{ text: "▶ / ‖", style: { top: "50%" } }],
  },

  "#00920106": {
    text: [{ text: "BT_1", style: { top: "50%" } }],
  },
  "#00920107": {
    text: [{ text: "BT_2", style: { top: "50%" } }],
  },
  "#00920108": {
    text: [{ text: "BT_3", style: { top: "50%" } }],
  },
  "#00920130": {
    text: [
      {
        text: "2.4G",
        style: { top: "50%" },
      },
    ],
  },
  "#00920922": {
    text: [
      { text: "Win/", style: { top: "35%" } },
      { text: "Mac", style: { top: "65%" } },
    ],
  },
  "#00900001": {
    text: [{ text: "Esc `", style: { top: "50%" } }],
  },
  "#00921300": {
    text: [
      { text: "Add", style: { top: "35%" } },
      { text: "Touch Sen", style: { top: "65%", fontSize: "0.66em" } },
    ],
  },
  "#00920A02": {
    text: [{ text: "Reset", style: { top: "50%" } }],
  },
  "#00920900": {
    text: [
      { text: "Next", style: { top: "35%" } },
      { text: "LED", style: { top: "65%" } },
    ],
  },
  "#00920901": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Light+", style: { top: "65%" } },
    ],
  },
  "#00920902": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Light-", style: { top: "65%" } },
    ],
  },
  "#00920903": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920904": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed+", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920905": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed-", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920920": {
    text: [
      { text: "LED", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Color", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090B": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Light+", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090C": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Light-", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090D": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090E": {
    text: [
      { text: "Nameplate", style: { top: "35%", fontSize: "0.66em" } },
      { text: "Color", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#0092090F": {
    text: [
      { text: "Next", style: { top: "35%" } },
      { text: "Nameplate", style: { top: "65%", fontSize: "0.66em" } },
    ],
  },
  "#00920910": {
    text: [{ text: "Battery", style: { top: "50%" } }],
  },
  "#00920C0F": {
    text: [{ text: "Layer1", style: { top: "50%" } }],
  },
  "#00920C10": {
    text: [{ text: "Layer2", style: { top: "50%" } }],
  },
  "#00920C11": {
    text: [{ text: "Layer3", style: { top: "50%" } }],
  },
  "#00920C12": {
    text: [{ text: "Layer4", style: { top: "50%" } }],
  },
  "#00920C13": {
    text: [{ text: "Layer5", style: { top: "50%" } }],
  },
  "#00920C14": {
    text: [{ text: "Layer6", style: { top: "50%" } }],
  },
  "#00920C15": {
    text: [{ text: "Layer7", style: { top: "50%" } }],
  },
  "#00920C20": {
    text: [{ text: "Fn1", style: { top: "50%" } }],
  },
  "#00920C0B": {
    text: [{ text: "Fn2", style: { top: "50%" } }],
  },
  "#00920C22": {
    text: [{ text: "Fn3", style: { top: "50%" } }],
  },
  "#00920C23": {
    text: [{ text: "Fn4", style: { top: "50%" } }],
  },
  "#00920C24": {
    text: [{ text: "Fn5", style: { top: "50%" } }],
  },
  "#00920C25": {
    text: [{ text: "Fn6", style: { top: "50%" } }],
  },
  "#00920C26": {
    text: [{ text: "Fn7", style: { top: "50%" } }],
  },
  "#00910010": {
    text: [{ text: "S Fn1", style: { top: "50%" } }],
  },
  "#00910011": {
    text: [{ text: "S Fn2", style: { top: "50%" } }],
  },
  "#00910012": {
    text: [{ text: "S Fn3", style: { top: "50%" } }],
  },
  "#00910013": {
    text: [{ text: "S Fn4", style: { top: "50%" } }],
  },
  "#00910014": {
    text: [{ text: "S Fn5", style: { top: "50%" } }],
  },
  "#00910015": {
    text: [{ text: "S Fn6", style: { top: "50%" } }],
  },
  "#00910016": {
    text: [{ text: "S Fn7", style: { top: "50%" } }],
  },
};
